module.exports = __webpack_public_path__ + "3e458b20daa1cb59e338877c64f94cc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/irrigation1.jpg
// module id = 121
// module chunks = 1